import styled from 'styled-components';
import Icon from '../../_shared/components/Icon';
import Button from '../../_shared/components/Button';

export const StyledDealerProfile = styled.ul`
  background: ${({ theme }) => theme.COLORS.BASE};
  display: flex;
  flex-direction: column;
  height: max-content;
  z-index: 200;
  position: fixed;
  top: 53px;
  right: 40px;
  box-shadow: 0 0 12px 1px rgba(0, 0, 0, 0.3);
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  padding: 12px;
  opacity: ${props => (props.isDealerProfileOpen ? 1 : 0)};
  visibility: ${props => (props.isDealerProfileOpen ? 'visible' : 'hidden')};
  transition: 0.25s all ease-in-out;
  max-width: 220px;

  li {
    display: flex;
    justify-content: flex-start;
    cursor: pointer;
    min-width: 195px;
    font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};

    a,
    button {
      padding: 12px;
      width: 100%;
      letter-spacing: normal;
    }

    a {
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: flex-start;
    }

    &:hover {
      background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
    }

    &:first-of-type {
      margin-top: 12px;
    }
  }
`;

export const StyledProfile = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  padding: 6px 12px 18px 12px;
  display: flex;
`;

export const StyledNameContainer = styled.div`
  display: flex;
  flex-direction: column;

  a {
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.COLORS.DARK_BLUE};
    }
  }
`;

export const StyledName = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  margin-bottom: 8px;
  max-width: 130px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledIcon = styled(Icon)`
  height: 24px;
  max-width: 24px;
  margin-right: 16px;
`;

export const StyledButton = styled(Button)`
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  padding: 0;
  width: 100%;
  text-align: left;
  text-transform: capitalize;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const UpArrow = styled.div`
  position: absolute;
  top: -10px;
  right: 17px;
  width: 0;
  height: 0;
  border-bottom: 10px solid ${({ theme }) => theme.COLORS.TRANSPARENT};
  border-right: 10px solid ${({ theme }) => theme.COLORS.TRANSPARENT};
  border-top: 10px solid ${({ theme }) => theme.COLORS.BASE};
  border-left: 10px solid ${({ theme }) => theme.COLORS.BASE};
  border-radius: 3px 0;
  transform: rotate(45deg);
  z-index: 10;
`;
